import { useState } from 'react';
import Button from '@material-ui/core/Button';
import TechAppDialog from '../TechAppDialog';
import QuoteReportComponent from './QuoteReportComponent';

type OnSiteApprovalProperties = {
    workorder_id: number;
}

export default function OnSiteApprovalComponent(props: OnSiteApprovalProperties) {

    const closeDialog = () => {
        setShowApprovalForm(false);
    }

    const [showApprovalForm, setShowApprovalForm] = useState(false);
    return (
        <>
            <TechAppDialog open={showApprovalForm} title="On Site Approval Form" fullWidth={true}
                onClose={closeDialog} 
            >
                <QuoteReportComponent workorder_id={props.workorder_id} onClose={closeDialog} onOK={closeDialog}/>
            </TechAppDialog>
            <Button
                variant="contained"
                color="primary"
                onClick={() => {setShowApprovalForm(true)}}
            >
                Open On Site Approval Form
            </Button>
        </>
    )
}